import { ReactNode } from 'react';
import { MoveStruct, MoveValue } from '@mysten/sui.js/src/client';
import { OwnedObjectType } from './Inventory/OwnedObjects';
import { getImage } from '../../utils/utils';
import { useEssential } from '../App';

export interface IDisplayObject {
  item: OwnedObjectType;
  children: ReactNode;
}

// Function to extract fields from SudoCard MoveStruct
export function extractSudoCardFields(sudoCardFields: MoveStruct) {
  const fields = sudoCardFields as { [key: string]: MoveValue };

  const numberValue = fields.number as number | undefined;
  const tierValue = fields.tier as number | undefined;
  const levelValue = fields.level as number | undefined;
  const pointsValue = fields.points as number | undefined;

  // Return the extracted fields as an object
  return {
    number: numberValue,
    tier: tierValue,
    level: levelValue,
    points: pointsValue,
  };
}

export function DisplayObject({ item, children }: IDisplayObject) {
  const { consts } = useEssential();
  const image = getImage(item, consts);
  const { number, tier, level, points } = extractSudoCardFields(item.display);

  return (
    <div className="scard-container relative overflow-hidden text-center flex justify-between flex-col">
      <div className="relative cursor-pointer transition-transform hover:scale-[101%] overflow-hidden">
        <img
          src={item.display.image_url}
          className="overflow-hidden rounded-xl w-full aspect-square object-cover scale-[1.01]"
          alt="The display of the object"
        ></img>
      </div>

      <div className="p-4">
        {item.display.name && (
          <h3 className="text-clip text-left overflow-hidden">
            {item.display.name}
          </h3>
        )}

        {/* {item.display.description && (
          <p className="text-sm opacity-80 text-clip overflow-hidden">
            {item.display.description}
          </p>
        )} */}

        {/* <p className="text-xs break-words text-gray-400 py-3">{item.type}</p> */}
        {/* <p className="text-xs text-left break-words py-1">
          {item.objectId}
        </p> */}

        {tier && (
          <p className="text-xs text-left break-words py-1">Tier {tier}</p>
        )}

        {level && (
          <p className="text-xs text-left break-words py-1">Level {level}</p>
        )}

        {/* {points && (
          <p className="text-xs text-left break-words py-1">
            Points {points}
          </p>
        )} */}

        {/* button actions */}
        <div className="grid lg:grid-cols-2 gap-5 mt-6">{children}</div>
      </div>
    </div>
  );
}
